<script>
export default {
  name: "VPageCtn",
  methods: {
    pageLeave: () => {
      document.querySelector(".page").classList.remove("loaded");
    },
    pageEnter: () => {
      document.querySelector(".page").classList.add("loaded");
    }
  }
};
</script>

<template>
  <div class="page">
    <slot />
  </div>
</template>
